enum Rate {
    Decrease = -1,
    Static = 0,
    Increase = 1,
}

export default Rate;
